import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './index.module.css';

import ScrollBlock from '@components/common/scroll-block';

import utils from '@utils';

class ScrollBlockImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      src: [],
    };

    this.scrollRef = React.createRef();

    if (props.src) {
      this.onChange(props.src);
    }
  }

  onChange(src) {
    let promises = [];

    for (let i = 0; i < src.length; i++) {
      promises.push(utils.waitForImage(src[i]));
    }

    Promise.all(promises).then(() => {
      this.setState({ src }, () => {
        this.scrollRef.current.onChange(0);
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this.onChange(this.props.src);
    }
  }

  render() {
    return (
      <ScrollBlock {...this.props} wide={true} ref={this.scrollRef}>
        {this.state.src && this.state.src.length > 0 && (
          this.state.src.map((image, idx) => (<img
            className={styles.image}
            key={idx}
            src={image}
            alt={this.props.alt}
            />))
        )}
      </ScrollBlock>
    );
  }
}

ScrollBlockImage.defaultProps = {
  children: '',
  src: [],
  alt: '',
};

ScrollBlockImage.propTypes = {
  children: PropTypes.any,
  src: PropTypes.array,
  alt: PropTypes.string,
};

export default ScrollBlockImage;
